import type { FlightItinerary } from '@shared/types';

/**
 * Departure airport through every layover to the final arrival airport,
 * e.g. "RSW → EWR" nonstop or "RSW → PHL → EWR" for a connection. The
 * layover city otherwise isn't shown anywhere on the flight card.
 */
export function routeCodes(itinerary: Pick<FlightItinerary, 'segments'>): string {
  const codes = [itinerary.segments[0].origin.code, ...itinerary.segments.map((s) => s.destination.code)];
  return codes.join(' → ');
}
